import React, { useEffect, useMemo, useState } from "react";
import { mapArrayToObject } from "../../../commonFunctions/arrayFunc";
import { extractVariables } from "../../../commonFunctions/fileFolderConfig";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import Input from "../../../components/FormComponents/Input";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import Textarea from "../../../components/FormComponents/Textarea";
import { useFormContext } from "../../../context/FormContext";

const RdbmsFormQuery = ({ allDbConnectors }) => {
  const { rdbmsConfig, setRdbmsConfig, renderFieldsData, renderFieldsArray } = useFormContext();
  const [fields, setFields] = useState({});

  const handlePrefillQuery = (value) => {
    setRdbmsConfig((prev) => ({
      ...prev,
      rdbms_query: {
        ...prev.rdbms_query,
        prefill_query: value
      }
    }));
  };
  const handleSubmitQuery = (value) => {
    setRdbmsConfig((prev) => ({
      ...prev,
      rdbms_query: {
        ...prev.rdbms_query,
        submit_query: value
      }
    }));
  };
  useEffect(() => {
    const arrayCopy = [...renderFieldsArray];
    arrayCopy.sort((a, b) => a.y - b.y);
    const newArray = arrayCopy.map((field) => {
      return renderFieldsData.current[field.i];
    });
    const { result } = mapArrayToObject(newArray);
    setFields(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className=" activity-blocks-outer" style={{ flexWrap: "wrap" }}>
      <div className="activity-blocks query_box">
        <RdbmsPrefillQuery
          allDbConnectors={allDbConnectors}
          prefillQuery={rdbmsConfig.rdbms_query?.prefill_query || ""}
          fields={fields}
          onChange={handlePrefillQuery}
        />
      </div>
      <div className="activity-blocks query_box">
        <RdbmsSubmitQuery
          allDbConnectors={allDbConnectors}
          submitQuery={rdbmsConfig.rdbms_query.submit_query}
          fields={fields}
          onChange={handleSubmitQuery}
        />
      </div>
    </div>
  );
};
const RdbmsSubmitQuery = ({ allDbConnectors, submitQuery, fields, onChange }) => {
  const [variable, setVariable] = useState([]);
  const handleChangeSubmitQuery = (e) => {
    const value = e.target.value;
    const data = extractVariables(value);
    setVariable(data);
    onChange({ ...submitQuery, query: value });
  };
  const addSubmitMap = (newMap) => {
    const newSubmitQuery = { ...submitQuery, varmap: [...(submitQuery.varmap || []), newMap] };
    onChange(newSubmitQuery);
  };
  const handleChangeFilterMap = (newMap) => {
    const newSubmitQuery = {
      ...submitQuery,
      varmap: newMap
    };
    onChange(newSubmitQuery);
  };

  const selectedDbUsers = useMemo(() => {
    if (!submitQuery?.database) return [];
    return allDbConnectors.find((db) => db.id === submitQuery.database)?.users || [];
  }, [submitQuery.database, allDbConnectors]);

  useEffect(() => {
    const data = extractVariables(submitQuery.query);
    setVariable(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="builder_form">
      <div className="flex_column gap_2">
        <h3 className="block-header-inside">Submit Query</h3>
        <SingleSelectBox
          options={allDbConnectors}
          selectedData={submitQuery.database}
          onChange={(data) => onChange({ ...submitQuery, database: data.id })}
          label="Database"
        />
        {submitQuery?.database && (
          <SingleSelectBox
            options={selectedDbUsers}
            selectedData={submitQuery.db_user}
            onChange={(data) => onChange({ ...submitQuery, db_user: data.user_id })}
            valueKey="user_id"
            labelKey={["name"]}
            label="Add User"
          />
        )}
        <Textarea value={submitQuery.query} label="Query" onChange={handleChangeSubmitQuery} />
      </div>

      <div>
        <h4 className="block-header-inside">Map</h4>
        <AddSubmitMap fields={fields} onAdd={addSubmitMap} variable={variable} />
        <RdbmsFormVariableMapping map={submitQuery.varmap || []} onChange={handleChangeFilterMap} fields={fields} />
      </div>
    </div>
  );
};
const AddSubmitMap = ({ fields, onAdd, variable }) => {
  const initialMapState = {
    source: "",
    type: "form",
    target: ""
  };

  const [mapData, setMapData] = useState(initialMapState);
  const [errors, setErrors] = useState({ source: "", target: "" });

  const handleChangeMap = (key, value) => {
    setMapData((prevData) => ({ ...prevData, [key]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [key]: "" }));
  };

  const handleAddMap = () => {
    const newErrors = {
      source: mapData.source ? "" : "Source is required",
      target: mapData.target ? "" : "Target is required"
    };

    if (newErrors.source || newErrors.target) {
      setErrors(newErrors);
      return;
    }

    onAdd(mapData);
    setMapData(initialMapState);
  };
  const typeOptions = ["form", "token"];
  return (
    <div className="d_flex gap_2 align_end mb_3" style={{ width: "450px" }}>
      {mapData.type === "form" ? (
        <SingleSelectBox
          options={Object.values(fields)}
          labelKey={["label"]}
          selectedData={mapData.source}
          containerClassName="m_0"
          onChange={(data) => handleChangeMap("source", data.id)}
          error={errors.source}
          label="Field"
        />
      ) : (
        <Input value={mapData.source} label="Source" onChange={(e) => handleChangeMap("source", e.target.value)} />
      )}
      <SingleSelectBox
        options={typeOptions}
        selectedData={mapData.type}
        containerClassName="m_0"
        onChange={(data) => handleChangeMap("type", data)}
        label="Type"
      />
      <SingleSelectBox
        options={variable}
        selectedData={mapData.target}
        containerClassName="m_0"
        onChange={(data) => handleChangeMap("target", data)}
        error={errors.target}
        label="Variable"
      />
      <ButtonActionIcon type="add" onClick={handleAddMap} />
    </div>
  );
};

const RdbmsPrefillQuery = ({ allDbConnectors, prefillQuery, onChange, fields }) => {
  const [variable, setVariable] = useState([]);
  const handleChangePrefillQuery = (e) => {
    const value = e.target.value;
    const data = extractVariables(value);
    setVariable(data);
    onChange({ ...prefillQuery, query: value });
  };
  const handleChangeFilterMap = (data) => {
    onChange({ ...prefillQuery, filter_varmap: data });
  };
  const addPrefillFilterMap = (addMap) => {
    onChange({
      ...prefillQuery,
      filter_varmap: [...(prefillQuery.filter_varmap || []), addMap]
    });
  };

  const addPrefillDataMap = (addData) => {
    onChange({ ...prefillQuery, data_varmap: [...(prefillQuery.data_varmap || []), addData] });
  };
  const handleChangeDataMap = (data) => {
    onChange({ ...prefillQuery, data_varmap: data });
  };

  const selectedDbUsers = useMemo(() => {
    if (!prefillQuery?.database) return [];
    return allDbConnectors.find((db) => db.id === prefillQuery.database)?.users || [];
  }, [prefillQuery.database, allDbConnectors]);

  useEffect(() => {
    const data = extractVariables(prefillQuery.query);
    setVariable(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="builder_form">
      <div className="flex_column gap_2">
        <h3 className="block-header-inside">Prefill Query</h3>
        <SingleSelectBox
          options={allDbConnectors}
          selectedData={prefillQuery.database}
          onChange={(data) => onChange({ ...prefillQuery, database: data.id })}
          label="Database"
        />
        {prefillQuery?.database && (
          <SingleSelectBox
            options={selectedDbUsers}
            selectedData={prefillQuery.db_user}
            onChange={(data) => onChange({ ...prefillQuery, db_user: data.user_id })}
            valueKey="user_id"
            labelKey={["name"]}
            label="Add User"
          />
        )}
        <Textarea value={prefillQuery.query} label="Query" onChange={handleChangePrefillQuery} />
      </div>

      <div>
        <h4 className="block-header-inside">Filter Map</h4>
        <AddPrefillFilter variable={variable} onAdd={addPrefillFilterMap} />
        <RdbmsFormVariableMapping
          map={prefillQuery.filter_varmap || []}
          onChange={handleChangeFilterMap}
          fields={fields}
        />
      </div>

      <div>
        <h4 className="block-header-inside">Data Map</h4>
        <AddPrefillData variable={variable} fields={fields} onAdd={addPrefillDataMap} />
        <RdbmsFormVariableMapping map={prefillQuery.data_varmap || []} onChange={handleChangeDataMap} fields={fields} />
      </div>
    </div>
  );
};
const AddPrefillFilter = ({ variable, onAdd }) => {
  const initialMapState = {
    source: "",
    type: "",
    target: ""
  };

  const [mapData, setMapData] = useState(initialMapState);
  const [errors, setErrors] = useState({ source: "", target: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMapData({ ...mapData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleChangeVariable = (value) => {
    setMapData({ ...mapData, target: value });
    setErrors({ ...errors, target: "" });
  };

  const handleAddMap = () => {
    const newErrors = {
      source: mapData.source.trim() ? "" : "Source is required",
      target: mapData.target ? "" : "Target is required"
    };

    if (newErrors.source || newErrors.target) {
      setErrors(newErrors);
      return;
    }

    onAdd({ ...mapData, type: "token" });
    setMapData(initialMapState);
  };

  return (
    <div className="d_flex gap_2 align_end mb_1" style={{ width: "450px" }}>
      <Input label="Source" value={mapData.source} name="source" error={errors.source} onChange={handleChange} />
      <SingleSelectBox
        label="Variable"
        options={variable}
        containerClassName="m_0"
        selectedData={mapData.target}
        onChange={handleChangeVariable}
        error={errors.target}
      />
      <ButtonActionIcon type="add" onClick={handleAddMap} />
    </div>
  );
};

const AddPrefillData = ({ variable, onAdd, fields }) => {
  const initialMapState = {
    source: "",
    type: "",
    target: ""
  };

  const [mapData, setMapData] = useState(initialMapState);
  const [errors, setErrors] = useState({ source: "", target: "" });

  const handleChangeMap = (key, value) => {
    setMapData({ ...mapData, [key]: value });
    setErrors({ ...errors, [key]: "" });
  };

  const handleAddMap = () => {
    const newErrors = {
      source: mapData.source ? "" : "Source is required",
      target: mapData.target ? "" : "Target is required"
    };

    if (newErrors.source || newErrors.target) {
      setErrors(newErrors);
      return;
    }

    onAdd({ ...mapData, type: "form" });
    setMapData(initialMapState);
  };

  return (
    <div className="d_flex gap_2 align_end mb_1" style={{ width: "450px" }}>
      <SingleSelectBox
        options={variable}
        selectedData={mapData.source}
        containerClassName="m_0"
        onChange={(data) => handleChangeMap("source", data)}
        error={errors.source}
        label="Variable"
      />
      <SingleSelectBox
        options={Object.values(fields)}
        labelKey={["label"]}
        selectedData={mapData.target}
        containerClassName="m_0"
        onChange={(data) => handleChangeMap("target", data.id)}
        error={errors.target}
        label="Field"
      />
      <ButtonActionIcon type="add" onClick={handleAddMap} />
    </div>
  );
};

const RdbmsFormVariableMapping = ({ map, onChange, fields }) => {
  const handleDelete = (index) => {
    const updatedData = map.filter((_, i) => i !== index);
    onChange(updatedData);
  };
  if (map.length === 0) {
    return <div>No filter map added yet.</div>;
  }
  return (
    <table border="1">
      <thead>
        <tr>
          <th>Source</th>
          <th>Type</th>
          <th>Target</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {map.map((item, index) => (
          <tr key={index}>
            <td>{fields[item.source]?.label || item.source}</td>
            <td>{item.type}</td>
            <td>{fields[item.target]?.label || item.target}</td>
            <td>
              <ButtonActionIcon type={"delete"} onClick={() => handleDelete(index)} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default RdbmsFormQuery;
export { RdbmsFormVariableMapping };
